import tw from 'twin.macro'
import React, { useContext } from 'react'
import { MCsContext } from '../mcs/MCs.context'
import { MCsTableContext } from '../mcs-table/MCsTable.context'
import { TableTagsSelect } from 'src/components/shared/table/TableTagsSelect'
import { TableSearch } from 'src/components/shared/table/TableSearch'
import useCheckPermissions from 'src/hooks/useCheckPermissions'
import { UserPermission } from 'src/constants/user'
import { GridColumnsSelect } from 'src/components/shared/grid/grid-columns-select/GridColumnsSelect'

export const MCsHeader = () => {
  const { setSearchQuery, searchQuery } = useContext(MCsContext)
  const {
    tagsFilter,
    setTagsFilter,
    columnsConfig,
    columnVisibilityModel,
    pinnedColumns,
    lockedColumns,
    onToggleColumnVisibility,
    onColumnVisibilityModelChange,
    onPinColumn,
    onUnpinColumn,
  } = useContext(MCsTableContext)
  const { hasPermission } = useCheckPermissions()

  return (
    <div
      css={tw`flex flex-row items-center justify-between px-4 py-3 bg-white border-0 border-b border-t border-solid border-[#EDEDED]`}
    >
      <div css={tw`flex flex-row items-center gap-4`}>
        {columnsConfig.length > 0 && (
          <GridColumnsSelect
            columnsConfig={columnsConfig}
            columnVisibilityModel={columnVisibilityModel}
            pinnedColumns={pinnedColumns}
            lockedColumns={lockedColumns}
            onToggleColumnVisibility={onToggleColumnVisibility}
            onColumnVisibilityModelChange={onColumnVisibilityModelChange}
            onPinColumn={onPinColumn}
            onUnpinColumn={onUnpinColumn}
          />
        )}
        <TableSearch
          searchQuery={searchQuery}
          onChangeSearchQuery={setSearchQuery}
          inputDataTestId="master-contractors-list-main-search-input"
          clearButtonDataTestId="master-contractors-list-main-search-clear-btn"
        />
        {hasPermission(UserPermission.TagsView) && (
          <TableTagsSelect
            selectedTags={tagsFilter}
            setSelectedTags={setTagsFilter}
            triggerDataTestId="master-contractors-list-main-tags-menu-btn"
            clearAllDataTestId="master-contractors-list-main-tags-clear-all"
            manageOptionsDataTestId="master-contractors-list-main-tags-manage-options"
          />
        )}
      </div>
    </div>
  )
}
